// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddressComponent_input_send__sVIei {
  width: 92%;
  padding-left: 10px;
  outline: none;
  background-color: none;
  border: solid 1px #edebe9;
  height: 32px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.AddressComponent_input_copy_paste__eKg7a {
  width: 100%;
  max-width: 805px;
  padding-left: 10px;
  outline: none;
  background-color: none;
  border: solid 1px #edebe9;
  height: 32px;
  margin-bottom: 8px;

  box-sizing: border-box;
}

.AddressComponent_row_container__-RSjt {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.AddressComponent_label__UuMjB {
  width: 50px;
  text-align: right;
}

.AddressComponent_email_to_autocomplete__\\+zQ6l {
  width: 100%;
  max-width: 892px;
  background: white;
  margin-bottom: 8px;
  padding: 0 !important;
}

.AddressComponent_email_to_autocomplete__\\+zQ6l .MuiOutlinedInput-root {
  min-height: 32px !important;
  padding: 0 4px !important;
}

.AddressComponent_email_to_autocomplete__\\+zQ6l .MuiAutocomplete-input {
  padding: 4px 6px !important;
}

.AddressComponent_email_to_autocomplete_cp__BFMxK {
  width: 100%;
  max-width: 803px;
  background: white;
  margin-bottom: 8px;
}

.AddressComponent_email_to_autocomplete_cp__BFMxK .MuiOutlinedInput-root {
  min-height: 32px !important;
  padding: 0 4px !important;
}

.AddressComponent_email_to_autocomplete_cp__BFMxK .MuiAutocomplete-input {
  padding: 4px 6px !important;
}

.AddressComponent_mail_chip__UdwSj {
  height: 28px !important;
  margin-left: 4px;
  margin-top: 2px;
  padding: 0 !important;
}

.AddressComponent_send_email_form__cALL1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-weight: 300;
  font-size: 15px;
  text-align: right;
}

.AddressComponent_to_and_cc_button_container__xwulH {
  display: flex;
  width: 100%;
  max-width: 892px;
  padding: 0 !important;
  padding-left: 10px;
  flex-direction: row;
  justify-content: flex-end;
}

.AddressComponent_btn_default__2KXBf {
  color: var(--color-font-10) !important;

  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  margin-top: 10px;
  height: 33px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/RenderPopup/AddressComponent/AddressComponent.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;;EAElB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;;EAEtC,gDAAgD;EAChD,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".input_send {\n  width: 92%;\n  padding-left: 10px;\n  outline: none;\n  background-color: none;\n  border: solid 1px #edebe9;\n  height: 32px;\n  margin-bottom: 8px;\n  box-sizing: border-box;\n}\n\n.input_copy_paste {\n  width: 100%;\n  max-width: 805px;\n  padding-left: 10px;\n  outline: none;\n  background-color: none;\n  border: solid 1px #edebe9;\n  height: 32px;\n  margin-bottom: 8px;\n\n  box-sizing: border-box;\n}\n\n.row_container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.label {\n  width: 50px;\n  text-align: right;\n}\n\n.email_to_autocomplete {\n  width: 100%;\n  max-width: 892px;\n  background: white;\n  margin-bottom: 8px;\n  padding: 0 !important;\n}\n\n.email_to_autocomplete :global(.MuiOutlinedInput-root) {\n  min-height: 32px !important;\n  padding: 0 4px !important;\n}\n\n.email_to_autocomplete :global(.MuiAutocomplete-input) {\n  padding: 4px 6px !important;\n}\n\n.email_to_autocomplete_cp {\n  width: 100%;\n  max-width: 803px;\n  background: white;\n  margin-bottom: 8px;\n}\n\n.email_to_autocomplete_cp :global(.MuiOutlinedInput-root) {\n  min-height: 32px !important;\n  padding: 0 4px !important;\n}\n\n.email_to_autocomplete_cp :global(.MuiAutocomplete-input) {\n  padding: 4px 6px !important;\n}\n\n.mail_chip {\n  height: 28px !important;\n  margin-left: 4px;\n  margin-top: 2px;\n  padding: 0 !important;\n}\n\n.send_email_form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-weight: 300;\n  font-size: 15px;\n  text-align: right;\n}\n\n.to_and_cc_button_container {\n  display: flex;\n  width: 100%;\n  max-width: 892px;\n  padding: 0 !important;\n  padding-left: 10px;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.btn_default {\n  color: var(--color-font-10) !important;\n\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n  margin-top: 10px;\n  height: 33px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input_send": `AddressComponent_input_send__sVIei`,
	"input_copy_paste": `AddressComponent_input_copy_paste__eKg7a`,
	"row_container": `AddressComponent_row_container__-RSjt`,
	"label": `AddressComponent_label__UuMjB`,
	"email_to_autocomplete": `AddressComponent_email_to_autocomplete__+zQ6l`,
	"email_to_autocomplete_cp": `AddressComponent_email_to_autocomplete_cp__BFMxK`,
	"mail_chip": `AddressComponent_mail_chip__UdwSj`,
	"send_email_form": `AddressComponent_send_email_form__cALL1`,
	"to_and_cc_button_container": `AddressComponent_to_and_cc_button_container__xwulH`,
	"btn_default": `AddressComponent_btn_default__2KXBf`
};
export default ___CSS_LOADER_EXPORT___;
